import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MediaList from './MediaList';
import MediaDetails from './MediaDetails';
import AppBar from './AppBar';

export default function App() {

  return (
    <>
    <AppBar />
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" index element={<MediaList/>} /> 
          <Route path="/:id" element={<MediaList/>} /> 
          <Route path="/details/:id" element={<MediaDetails/>} />
          <Route path="/media/:id" element={<MediaList />} />
        </Routes>
        </BrowserRouter>
      </Box>
    </Container>
    </>
  );
}